module.exports = __webpack_public_path__ + "img/micad-coBranding.09717ef3.jpg";